import ArticleLive from './articleLive'

const articleLive = new ArticleLive()
articleLive.init()
